import { render, staticRenderFns } from "./BecomeAnAgent.vue?vue&type=template&id=35651dcd&scoped=true&"
import script from "./BecomeAnAgent.vue?vue&type=script&lang=js&"
export * from "./BecomeAnAgent.vue?vue&type=script&lang=js&"
import style0 from "./BecomeAnAgent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BecomeAnAgent.vue?vue&type=style&index=1&id=35651dcd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35651dcd",
  null
  
)

export default component.exports